namespace advisorop.domains {
    "use strict";

    export interface IMeeting {
        id?: number;

        idString?: string;

        title?: string;

        guid?: string;

        type?: domains.MeetingType;

        status?: domains.MeetingStatus;

        calendarType?: domains.CalendarType;

        startDate?: Date;

        endDate?: Date;

        isAllDay?: boolean;

        advisor?: domains.IAdvisor;

        participants?: Array<domains.IMeetingParticipant>;

        household?: domains.IHousehold;

        documents?: Array<domains.IDmsDocument>;
    }
}